/**
 * Pure helpers for Cashier finish / refresh response handling.
 * Keeps post-success refresh failures from looking like a failed baixa.
 */

const FINISH_REFRESH_SECONDARY_MESSAGE =
    'Lançamento realizado com sucesso, mas não foi possível atualizar a tela automaticamente. Atualize a página.';

/**
 * Prefer the action that started the HTTP call over mutable Vue state.
 */
function resolveRequestAction(form, fallbackAction) {
    if (form && form.params && form.params.action) {
        return form.params.action;
    }
    return fallbackAction;
}

/**
 * After finish succeeded, only refreshPedido failures are secondary UI issues.
 * A new finish with error:true must still surface as a real baixa error.
 */
function shouldTreatAsFinishRefreshFailure(action, finishSucceeded) {
    return !!finishSucceeded && action === 'refreshPedido';
}

function finishSuccessPlan(data) {
    return {
        successMessage:
            (data && data.message) || 'Lançamento realizado com sucesso',
        pedidoId: data ? data.pedido_id : null,
        secondaryMessage: FINISH_REFRESH_SECONDARY_MESSAGE,
        clearModal: true,
        shouldRefresh: true,
        shouldNotRetryFinish: true,
    };
}

module.exports = {
    FINISH_REFRESH_SECONDARY_MESSAGE,
    resolveRequestAction,
    shouldTreatAsFinishRefreshFailure,
    finishSuccessPlan,
};
